export class IndeedGeneralException extends Error {
  constructor(message: string) {
    super(message);
  }
}
